import { render, staticRenderFns } from "./settingWebhook.vue?vue&type=template&id=795790d2&scoped=true"
import script from "./settingWebhook.vue?vue&type=script&lang=js"
export * from "./settingWebhook.vue?vue&type=script&lang=js"
import style0 from "./settingWebhook.vue?vue&type=style&index=0&id=795790d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795790d2",
  null
  
)

export default component.exports